export const ADMIN = 'ADMIN';
export const USER = 'USER';
export const MEMBER = 'MEMBER';
export const INVESTOR = 'INVESTOR';
export const SUPER = "SUPER";